import {setWorkmix} from 'features/workmix';
import {setPracticeAreas} from 'features/practiceAreas';

import * as AreaOfExpertiseApi from '../api';
import setAreasOfExpertise from './setAreasOfExpertise';

const saveAreaOfExpertise = (id, areaOfExpertise) => async (dispatch, getState) => {
  const response = await AreaOfExpertiseApi.put(id, areaOfExpertise);

  dispatch(setAreasOfExpertise([response.data]));

  if (response.data.workmix) {
    dispatch(setWorkmix(response.data.workmix));
  }
  if (response.data.practice_areas) {
    dispatch(setPracticeAreas(response.data.practice_areas));
  }

  return response.data;
};

export default saveAreaOfExpertise;
